import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "certificateType" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "证件类型：", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.type === 'proxy')
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 0,
          modelValue: _ctx.proxyIdentityType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.proxyIdentityType = $event)),
          onChange: _ctx.changeIdentityType
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.identityOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.code,
                label: item.value,
                value: item.code
              }, null, 8, ["label", "value"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]))
      : _createCommentVNode("", true),
    (_ctx.type === 'agent')
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 1,
          modelValue: _ctx.agentIdentityType,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.agentIdentityType = $event)),
          onChange: _ctx.changeIdentityType
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.identityOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.code,
                label: item.value,
                value: item.code
              }, null, 8, ["label", "value"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]))
      : _createCommentVNode("", true),
    (_ctx.type === 'caseUser')
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 2,
          modelValue: _ctx.identityType,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.identityType = $event)),
          onChange: _ctx.changeIdentityType
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.identityOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.code,
                label: item.value,
                value: item.code
              }, null, 8, ["label", "value"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]))
      : _createCommentVNode("", true)
  ]))
}